/**
 * @title Menu Resize
 * @description Update Menu submenu on resize
 **/

const menuResize = () => {
	if (window.matchMedia("(min-width: 1385px)").matches) {
		const openNavigation = document.querySelector(".nav__active");

		if (openNavigation) {
			openNavigation.classList.remove("nav__active");
			openNavigation.setAttribute("aria-hidden", false);
			openNavigation.parentNode.classList.remove("nav-item--open");
		}
	}
};

export { menuResize };
